import { resetAuthorizationHeaders } from "../axiosInstance";

const logout = () => resetAuthorizationHeaders();
export default logout;
